import React from "react"
import { GetTable } from "../../common/components/DataTable"
import { TechnicianDto } from "../../generated"
import { Link } from "../../common/components/link";
import { links } from "../../routes";
import Store from "../TechiniciansStore";
import { Loading } from "../../common/components/loading";

const Table = GetTable<TechnicianDto>();
export default () => {
    const data = Store.useAll();
    if (!data)
        return <Loading />
    return <div className="card">
        <div className="card-header d-flex bg-theme align-items-center" >
            <h3 className="text-white flex-fill">Tecnici</h3>
            <Link to={links.techniciansNew} className="btn btn-outline-secondary"><i className="fas fa-plus" /> Aggiungi</Link>
        </div>
        <div className="card-body">
            <Table
                data={data}
                keySelector={x => x.id.toString()}
                filterables={[x => x.firstName, x => x.id, x => x.lastName]}
                styleSelector={x => x && { borderLeftColor: x.color, borderLeftStyle: "solid", borderLeftWidth: 10 } || undefined}
            >
                <Table.Column
                    template={x => x.id}
                    header="Id"
                    orderable
                    groupable={false}
                />
                <Table.Column
                    header="Nominativo"
                    template={x => <Link to={links.technicianEdit(x.id)}>{x.firstName} {x.lastName}</Link>}
                />
            </Table>
        </div>
    </div>
}
